module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 0,
        "faceMapType": 0,
        "livenessStatus": 0,
        "enrollmentIdentifier": "foo",
        "isLowQuality": false
    },
    "meta": {
        "code": 200,
        "message": "A FaceMap was found for that enrollmentIdentifier.",
        "ok": true,
        "m": {
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/enrollment-get-facemap.json.tpl